<template>
  <div>
    <div class="loading-state-container" v-if="loadLandingPageState.isLoading">
      <div class="container">
        <PreloaderSection />
      </div>
    </div>
    <div v-if="!loadLandingPageState.isLoading">
      <router-view
        v-if="!loadLandingPageState.error"
        :landingPage="landingPage" />
      <ErrorMessage
        v-if="loadLandingPageState.error"
        :error="loadLandingPageState.error"
        :redirectLink="'/landingpage'" />
    </div>
  </div>
</template>

<script>
// import _ from 'lodash';
import { loadLandingPagebyId } from '@/landingpage/api';
import PreloaderSection from '@/components/PreloaderSection.vue';
import ErrorMessage from '@/landingpage/ErrorMessage.vue';

export default {
  components: {
    PreloaderSection,
    ErrorMessage,
  },
  data() {
    return {
      landingPage: {
        title: null,
      },
      loadLandingPageState: {
        isLoading: false,
        error: null,
      },
    };
  },
  created() {
    this.load(this.landingPageId);
  },
  computed: {
    landingPageId() {
      return this.$route.params.id;
    },
  },
  methods: {
    async load(landingPageId) {
      this.loadLandingPageState.isLoading = true;
      try {
        const response = await loadLandingPagebyId(landingPageId);
        this.landingPage = response.data;
        this.loadLandingPageState.isLoading = false;
      } catch (error) {
        this.loadLandingPageState.error = error.response;
        this.loadLandingPageState.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';

.loading-state-container {
  margin-top: $spacer * 6;
}

</style>
